module.exports = __webpack_public_path__ + "static/pic03-36d6d1330466190303bee6d82d20dfaf.jpg";